module.exports = {
    loading: 'loading',
    idle: 'idle',
    success: 'success',
    error: 'error',
};